export default ({ type = 'pickup' } = {}) => ({
  type,

  init() {
    this.$watch('type', () => this.broadcast())
    this.$nextTick(() => this.broadcast())
  },

  get hasSelection() {
    return !!this.type
  },

  broadcast() {
    this.$dispatch('delivery-picker:change', {
      has_selection: this.hasSelection,
    })
  },
})
